/**
 * RefreshButton
 *
 * Shared button used in every admin tab's header. Standardises the look,
 * the spinning-icon-while-loading behaviour, and the loading label so that
 * every page in the admin panel has the exact same affordance.
 *
 * Usage:
 *   <RefreshButton onClick={fetchData} loading={isLoading} />
 *
 * Props:
 *   - onClick:      handler fired on click. Required.
 *   - loading:      when true, the icon spins, the label swaps to
 *                   `loadingLabel`, and the button becomes disabled.
 *   - label:        text to show when idle. Default 'Refresh'.
 *   - loadingLabel: text to show while loading. Default 'Refreshing…'.
 *   - title:        native tooltip. Default mirrors the visible text.
 */

import React from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import Button from './Button';

export default function RefreshButton({
  onClick,
  loading = false,
  label = 'Refresh',
  loadingLabel = 'Refreshing…',
  title,
}) {
  return (
    <Button
      variant="outline"
      onClick={onClick}
      disabled={loading}
      title={title || (loading ? loadingLabel : label)}
      leftIcon={<FiRefreshCw className={`text-[13px] ${loading ? 'animate-spin' : ''}`} />}
    >
      {loading ? loadingLabel : label}
    </Button>
  );
}
